import React, { useState, createContext, useContext } from 'react';
import { AuthState, User } from '../types';
const AuthContext = createContext<AuthState | undefined>(undefined);
export function AuthProvider({
  children
}: {
  children: ReactNode;
}) {
  const [user, setUser] = useState<User | null>(null);
  const login = (email: string) => {
    // Mock login
    setUser({
      id: '123',
      name: 'Товарищ Зритель',
      email,
      preferences: {
        ages: ['12+', '16+'],
        genres: ['Драма', 'Фантастика'],
        moods: ['Философское']
      }
    });
  };
  const logout = () => {
    setUser(null);
  };
  return <AuthContext.Provider value={{
    isLoggedIn: !!user,
    user,
    login,
    logout
  }} data-id="element-182">
      {children}
    </AuthContext.Provider>;
}
export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}